import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { VideoOverlayService } from '../../services/video-overlay.service';

@Component({
  selector: 'app-video-overlay',
  templateUrl: './video-overlay.component.html',
  styleUrls: ['./video-overlay.component.scss']
})
export class VideoOverlayComponent implements OnInit, OnDestroy {
  open = false;
  videoId: string | null = null;
  iframeSrc: SafeResourceUrl | null = null;
  sub: Subscription | null = null;

  constructor(private srv: VideoOverlayService, private sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.sub = this.srv.videoId$.subscribe(id => {
      this.videoId = id;
      this.open = !!id;
      if (id) {
        const src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0&showinfo=0&modestbranding=1`;
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(src);
      } else {
        // clear src to stop playback
        this.iframeSrc = null;
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  close() {
    this.srv.close();
  }

  onOverlayClick(e: MouseEvent) {
    // clicking outside content closes
    this.close();
  }

}
